import { observable, makeObservable } from "mobx";


export default class ForecastedProgressEntry {
  project;
  taskOrSummary;
  period = "";
  forecastedProgress = "";
  forecastedCost = "";

  constructor(
    project,
    taskOrSummary,
    period,
    forecastedProgress,
    forecastedCost
  ) {
    this.taskOrSummary = taskOrSummary;
    this.project = project;
    this.period = period;
    this.forecastedProgress = forecastedProgress;
    this.forecastedCost = forecastedCost;

    makeObservable(this, {
      period: observable,
      forecastedProgress: observable,
      forecastedCost: observable,
    })

  }

  toJS() {
    return {
      period: this.period,
      forecastedProgress: this.forecastedProgress,
      forecastedCost: this.forecastedCost,
    };
  }

  static fromJS(store, object) {
    const entry = new ForecastedProgressEntry();
    if (object != null) {
      entry.period = object.period;
      entry.forecastedProgress = object.forecastedProgress;
      entry.forecastedCost = object.forecastedCost;
      entry.project = store;
    }
    return entry;
  }
}
